import { PackagesService } from './../../../packages/services/packages.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { arLocale, defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import {
  HttpClient,
  HubConnection,
  HubConnectionBuilder,
  IHttpConnectionOptions,
} from '@microsoft/signalr';
import { environment } from 'projects/security-company-dashboard/src/environments/environment';
import {
  convertDateToString,
  LangService,
  language,
  mapTheme,
  ModalService,
  PAGINATION_SIZES,
  Roles,
} from 'projects/tools/src/public-api';
import { AuthService } from '../../../auth/services/auth.service';
import { AttendanceReport } from '../../../reports/models/attendance-report';
import { ReportsService } from '../../../reports/services/reports.service';
import { Loader } from '../../enums/loader.enum';
import { CompanyGuardsService } from '../../../guards/services/company-guards.service';
import { ClientsService } from './../../../client/services/clients.service';
import { ClientSiteService } from '../../../client/services/client-site.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Subscription, interval, map } from 'rxjs';
import { MapInfoWindow } from '@angular/google-maps';
import { DefaultRenderer, MarkerClusterer } from '@googlemaps/markerclusterer';
import { log } from 'console';
import { ZegoUIKitPrebuilt, ZegoUser } from '@zegocloud/zego-uikit-prebuilt';
import { ZIM } from 'zego-zim-web';
//import MarkerClusterer from '@google/markerclustererplus';
//import { DefaultRenderer } from '@googlemaps/markerclusterer';
//import { MarkerClusterer } from '@googlemaps/markerclusterer';
//import MarkerClusterer from "@google/markerclusterer";

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow | undefined;
  @ViewChild('compass') compass!: ElementRef;
  filterDate = new FormControl();
  maxDate = new Date();
  message!: string;
  statisticData!: any;
  flag: boolean = true;
  sites: any;
  id!: number;
  siteId!: any;
  siteFilter: boolean = false;
  totalHoure!: string;
  totalWorkHoure!: any;
  totalBrackHoure!: any;
  totalExstraTime!: any;
  mainLocation = new google.maps.LatLng({
    lat: 23.8859,
    lng: 45.0792,
  });
  data: any;
  style = mapTheme;
  maxZoom = 40;
  statistic!: any;
  private _hubConnection!: HubConnection;
  report!: AttendanceReport[];
  date!:any;
  yesterday!: Date;
  checkedIn: AttendanceReport[] = [];
  withDrawned:AttendanceReport[]=[];
  checkedOut: AttendanceReport[] = [];
  drawal: AttendanceReport[]=[];
  break: AttendanceReport[] = [];
  markers: { lat: any; lng: any; name: string ;siteLocationName:string,securityCompanyName:string ,
    guardCode:number , guardImage:string ,phoneNumber:number , nationalId:number,branchName:string,
     clientName:string , siteNumber:number , supervisorName:string ,shiftName:string , startTime:string , age:number , birthDate:string}[] = [];
  guardsids: any[] = [];
  dateToday = new Date();
  lastDate =
    this.dateToday.getMonth() +
    1 +
    '-' +
    this.dateToday.getDate() +
    '-' +
    this.dateToday.getFullYear();
  newDate = new Date(this.dateToday.setMonth(this.dateToday.getMonth() - 1));
  firstDate =
    this.newDate.getMonth() +
    1 +
    '-' +
    this.newDate.getDate() +
    '-' +
    this.newDate.getFullYear();
  hide!: boolean;
  companyId!: any;
  securityCompanyClientId!: any;
  locationId!: any;
  branches!:any;
  branchId!:any;
  branchFilter:boolean=false;
  isMainBranch:boolean=false;
  infoContent!: string;
  guardDetailsId="DetailsIdddd";
  withdrawndetailsId="withdrawndetailsId"
  withdrawnApprove='withdrawnApprove'
  guardDetails!:any;
  guardWithDrawns!:any;
  guardDrawnDetails!:any;
  withdrawalStatus!:number;
  allCheckIn: AttendanceReport[] = [];
  allCheckOut: AttendanceReport[] = [];
  allBreak: AttendanceReport[] = [];
  withdrawnGuardDetails!: any;
  searchKey='';
  startDate!:any;
  endDate!:any;
  timerSubscription!: Subscription;
  public days: number = 0;
  public hours: number = 0;
  public minutes: number = 0;
  public seconds: number = 0;
  mapMarkers: any = [];
  markerCluster: any;
  reasonForm = new FormGroup({
    Notes: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(2),
    ]),
  });
  currentUser!:any;
  zg!:ZegoUIKitPrebuilt
  constructor(
    private auth: AuthService,
    private reports: ReportsService,
    public lang: LangService,
    private PackagesService: PackagesService,
    private localeService: BsLocaleService,
    private _model:ModalService
  ) { 

    this.currentUser=this.auth.snapshot.userInfo
   // console.log(this.currentUser);
    let today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    let formattedDate = yesterday.toISOString().slice(0, 10);
   // console.log(formattedDate);
    
    this.companyId = this.auth.snapshot.userInfo?.id;
    //this.getAllReports()
   // this.connect();
    let role = this.auth.snapshot.userIdentity?.role;
    let isMainBranch = this.auth.snapshot.userInfo?.securityCompanyBranch.isMainBranch
    if (role == Roles.SecuritCompany || isMainBranch) {
      this.isMainBranch = true;
      console.log(isMainBranch);
    } else {
      this.isMainBranch = false;
    //  console.log(isMainBranch);
    }
    const hours = new Date().getHours();
    if (hours >= 0 && hours < 12) {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let formattedDate = yesterday.toISOString().slice(0, 10);
      this.startDate = formattedDate;
      this.endDate =  convertDateToString(new Date());
     // console.log(this.startDate,this.endDate);
      
    } else {
      this.startDate = convertDateToString(new Date());
      this.endDate =  convertDateToString(new Date());
     // console.log(this.startDate,this.endDate);
    }
 
  }

  ngOnInit(): void {
    this.getMarker();
   // this.getAllReports()
    let liveTrackingDisplay =
      this.PackagesService.myPackage.getValue().liveTracking;
    if (!liveTrackingDisplay) {
      this.hide = false;
    } else {
      this.hide = true;
    }
    this.onDateChange();
    
   // this.getStatisticAllCLient(this.firstDate, this.lastDate);
  //this.initMap();

   
  const userID = this.currentUser.id.toString();
  const userName = this.currentUser.accountName;
  const appID = 321913267;
  const serverSecret = "70d79dd72761a43d4a3add639d7c9740";
  const roomID = `1`;
  console.log("Generated userID:", userID);
  console.log("Generated userName:", userName);
  console.log("Generated roomID:", roomID);

 // Generate the test token
  const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(appID, serverSecret, "", userID, userName);
//  console.log("Generated token:", TOKEN);

  // Initialize ZegoUIKitPrebuilt with the token
 this.zg = ZegoUIKitPrebuilt.create(TOKEN);
  console.log("Created ZegoUIKitPrebuilt instance:", this.zg);

  // Add plugins such as ZIM
  this.zg.addPlugins({ ZIM });

  this.zg.setCallInvitationConfig({
    enableNotifyWhenAppRunningInBackgroundOrQuit: true,
})


  }

   initMap(): void {
  
    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: this.mainLocation,
        zoom: 5,
        heading: 320,
        tilt: 47.5,
        mapId: "90f87356969d889c",
      }
    );
  
    const buttons: [string, string, number, google.maps.ControlPosition][] = [
      ["→", "rotate", 20, google.maps.ControlPosition.LEFT_CENTER],
      ["←", "rotate", -20, google.maps.ControlPosition.RIGHT_CENTER],
      ["↓", "tilt", 20, google.maps.ControlPosition.TOP_CENTER],
      ["↑", "tilt", -20, google.maps.ControlPosition.BOTTOM_CENTER],
    ];
  
    buttons.forEach(([text, mode, amount, position]) => {
      const controlDiv = document.createElement("div");
      const controlUI = document.createElement("button");
  
      controlUI.classList.add("ui-button");
      controlUI.innerText = `${text}`;
      controlUI.addEventListener("click", () => {
        adjustMap(mode, amount);
      });
      controlDiv.appendChild(controlUI);
      map.controls[position].push(controlDiv);
    });
  
    const adjustMap = function (mode: string, amount: number) {
      switch (mode) {
        case "tilt":
          map.setTilt(map.getTilt()! + amount);
          break;
        case "rotate":
          map.setHeading(map.getHeading()! + amount);
          break;
        default:
          break;
      }
    };
  }
  
  // declare global {
  //   interface Window {
  //     initMap: () => void;
  //   }
  // }
  // window.initMap = initMap;
 

  initDatePiker() {
    defineLocale('ar', arLocale);
    defineLocale('en', enGbLocale);
    this.lang.language.subscribe((res) => {
      res === language.ar
        ? this.localeService.use('ar')
        : this.localeService.use('en');
    });
  }
  onDateChange() {
    this.filterDate.valueChanges
      .pipe(
        map((val: any) => ({
          start: convertDateToString(val[0]),
          end: convertDateToString(val[1]),
        }))
      )
      .subscribe((val) => {
        let role = this.auth.snapshot.userIdentity?.role;
        let isMainBranch = this.auth.snapshot.userInfo?.securityCompanyBranch.isMainBranch
        if (role == Roles.SecuritCompany || isMainBranch) {
          this.isMainBranch = true;
         /// console.log(isMainBranch);
          
          // this.reports
          //   .getData(1083, val.start, val.end, Loader.yes)
          //   .subscribe((response) => {
          //     this.reports.statisticData.next(response);
          //   });
        } else {
          this.isMainBranch = false;
        //  console.log(isMainBranch);
          // this.reports
          //   .getDataByBranch(1083, val.start, val.end, Loader.yes)
          //   .subscribe((response) => {
          //     this.reports.statisticData.next(response);
          //   });
        }
       // this.getStatistic(val.start, val.end, 1083);
      });
  }
  // getStatistic(date1: string, date2: string, clientId: number) {

  //   let role = this.auth.snapshot.userIdentity?.role;
  //   let isMainBranch = this.auth.snapshot.userInfo?.securityCompanyBranch.isMainBranch
  //   if (role == Roles.SecuritCompany || isMainBranch) {
  //     this.reports
  //       .getAttendanceStatisitcReportByClient(date1, date2, 1083, Loader.no)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.statistic = res;
  //           this.totalWorkHoure = this.statistic.totalWorkHoure;
  //           this.totalBrackHoure = this.statistic.totalBrackHoure;
  //           this.totalExstraTime = this.statistic.totalExstraTime;
  //           let h =
  //             Number(this.totalWorkHoure.toString().split(':')[0]) +
  //             Number(this.totalExstraTime.toString().split(':')[0]);
  //           let m =
  //             Number(this.totalWorkHoure.toString().split(':')[1]) +
  //             Number(this.totalExstraTime.toString().split(':')[1]);
  //           if (m > 59) {
  //             h += Math.floor(m / 60);
  //             m %= 60;
  //           }
  //           this.totalHoure = Math.round(h) + ':' + Math.round(m);
  //           let total1 = `${this.totalWorkHoure.toString().split(':')[0]}:${this.totalWorkHoure.toString().split(':')[1]}`
  //           this.totalWorkHoure = total1

  //           let total2 = `${this.totalExstraTime.toString().split(':')[0]}:${this.totalExstraTime.toString().split(':')[1]}`
  //           this.totalExstraTime = total2
  //           let total3 = `${this.totalBrackHoure.toString().split(':')[0]}:${this.totalBrackHoure.toString().split(':')[1]}`
  //           this.totalBrackHoure = total3

  //         }
  //       });
  //   }
  //   else {
  //     this.reports
  //       .getAttendanceStatisitcReportByClientAndBranch(date1, date2, 1083, Loader.no)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.statistic = res;
  //           this.totalWorkHoure = this.statistic.totalWorkHoure;
  //           this.totalBrackHoure = this.statistic.totalBrackHoure;
  //           this.totalExstraTime = this.statistic.totalExstraTime;
  //           let h =
  //             Number(this.totalWorkHoure.toString().split(':')[0]) +
  //             Number(this.totalExstraTime.toString().split(':')[0]);
  //           let m =
  //             Number(this.totalWorkHoure.toString().split(':')[1]) +
  //             Number(this.totalExstraTime.toString().split(':')[1]);
  //           if (m > 59) {
  //             h += Math.floor(m / 60);
  //             m %= 60;
  //           }
  //           this.totalHoure = Math.round(h) + ':' + Math.round(m);
  //           let total1 = `${this.totalWorkHoure.toString().split(':')[0]}:${this.totalWorkHoure.toString().split(':')[1]}`
  //           this.totalWorkHoure = total1

  //           let total2 = `${this.totalExstraTime.toString().split(':')[0]}:${this.totalExstraTime.toString().split(':')[1]}`
  //           this.totalExstraTime = total2
  //           let total3 = `${this.totalBrackHoure.toString().split(':')[0]}:${this.totalBrackHoure.toString().split(':')[1]}`
  //           this.totalBrackHoure = total3

  //         }
  //       });
  //   }


  // }
  // getStatisticAllCLient(date1: string, date2: string) {

  //   let role = this.auth.snapshot.userIdentity?.role;
  //   let isMainBranch = this.auth.snapshot.userInfo?.securityCompanyBranch.isMainBranch
  //   if (role == Roles.SecuritCompany || isMainBranch) {
  //     this.reports
  //       .getAttendanceStatisitcReport(date1, date2, Loader.no)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.statistic = res;
  //           this.totalWorkHoure = this.statistic.totalWorkHoure;
  //           this.totalBrackHoure = this.statistic.totalBrackHoure;
  //           this.totalExstraTime = this.statistic.totalExstraTime;
  //           let h =
  //             Number(this.totalWorkHoure.toString().split(':')[0]) +
  //             Number(this.totalExstraTime.toString().split(':')[0]);
  //           let m =
  //             Number(this.totalWorkHoure.toString().split(':')[1]) +
  //             Number(this.totalExstraTime.toString().split(':')[1]);
  //           if (m > 59) {
  //             h += Math.floor(m / 60);
  //             m %= 60;
  //           }
  //           this.totalHoure = Math.round(h) + ':' + Math.round(m);
  //           let total1 = `${this.totalWorkHoure.toString().split(':')[0]}:${this.totalWorkHoure.toString().split(':')[1]}`
  //           this.totalWorkHoure = total1

  //           let total2 = `${this.totalExstraTime.toString().split(':')[0]}:${this.totalExstraTime.toString().split(':')[1]}`
  //           this.totalExstraTime = total2
  //           let total3 = `${this.totalBrackHoure.toString().split(':')[0]}:${this.totalBrackHoure.toString().split(':')[1]}`
  //           this.totalBrackHoure = total3

  //         }
  //       });
  //   } else {
  //     this.reports
  //       .getAttendanceStatisitcReportByBranch(date1, date2, Loader.no)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.statistic = res;
  //           this.totalWorkHoure = this.statistic.totalWorkHoure;
  //           this.totalBrackHoure = this.statistic.totalBrackHoure;
  //           this.totalExstraTime = this.statistic.totalExstraTime;
  //           let h =
  //             Number(this.totalWorkHoure.toString().split(':')[0]) +
  //             Number(this.totalExstraTime.toString().split(':')[0]);
  //           let m =
  //             Number(this.totalWorkHoure.toString().split(':')[1]) +
  //             Number(this.totalExstraTime.toString().split(':')[1]);
  //           if (m > 59) {
  //             h += Math.floor(m / 60);
  //             m %= 60;
  //           }
  //           this.totalHoure = Math.round(h) + ':' + Math.round(m);
  //           let total1 = `${this.totalWorkHoure.toString().split(':')[0]}:${this.totalWorkHoure.toString().split(':')[1]}`
  //           this.totalWorkHoure = total1

  //           let total2 = `${this.totalExstraTime.toString().split(':')[0]}:${this.totalExstraTime.toString().split(':')[1]}`
  //           this.totalExstraTime = total2
  //           let total3 = `${this.totalBrackHoure.toString().split(':')[0]}:${this.totalBrackHoure.toString().split(':')[1]}`
  //           this.totalBrackHoure = total3

  //         }
  //       });
  //   }

  // }
  getMarker() {

    this.getAllReports()

  }
  // private connect(): void {
  //   let token = this.auth.snapshot.userIdentity?.token
  //   const options: IHttpConnectionOptions = {
  //     accessTokenFactory: () => {
  //       // Handle the case where token is null or undefined
  //       if (token === null || token === undefined) {
  //         return ''; // or another default value
  //       }
    
  //       return Promise.resolve(token);
  //     }
  //   };
  //   this._hubConnection = new HubConnectionBuilder()
  //     .withUrl(environment.hub , options)
  //     .build();

  //   this._hubConnection
  //     .start()
  //     .then(() => {
  //       this._hubConnection
  //         .invoke('AddToGroup', `${this.auth.snapshot.userInfo?.id}-attendance`)
  //         .then(() => {
  //           this._hubConnection.on('ReceiveMessage', () => {
  //             console.log("signalR");
              
             
  //           });
  //         });
  //     })
  //     .catch((err) =>
  //       console.log('error while establishing signalr connection: ' + err)
  //     );
  // }

  // ngOnDestroy(): void {
  //   //Called once, before the instance is destroyed.
  //   //Add 'implements OnDestroy' to the class.
  //   this._hubConnection.stop();
  // }
  getDataFilter(type: string) {
    if(type == 'branch'){
      this.branchFilter=true;
      this.branches=null;
      this.branchId=[];
      this.siteFilter = false;
      this.markers = [];
      this.sites=null;
      this.getClients();
        }else
        if (type == 'client') {
          this.siteFilter = false;
          this.siteId = [];
          this.sites = null;
          this.getClients();
        } else {
          this.data = [];
          this.siteFilter = true;
          this.getClients();
        }
  }
  getClients() {
    let AppUserId = this.auth.snapshot.userInfo?.appUser.id
    this.reports.GlobalApiFilterGetAllSecurityCompanyClientForUserSecurity(AppUserId).subscribe((res) => {
      this.data = ((res as any[]) || []).map((i: any) => { if (!i.nameEN) { i.nameEN = i.nameEn || i.name; i.nameEn = i.nameEN; } return i; });
    })
  }
  display(event: any) {
    this.securityCompanyClientId = [event.value];
    this.reports.clientId.next(1083);
    this.flag = false;
    this.branchId = [];
    this.branches=null;
    this.siteId=[];
    this.markers = [];
   // this.getMarker();
    //.getStatistic(this.firstDate, this.lastDate, 1083);
    if(this.siteFilter==true){
      //console.log('sitefilter');
      this.getMarker();
      let AppUserId = this.auth.snapshot.userInfo?.appUser.id
      this.reports.GlobalApiFilterGetAllSiteLocationByUserAndSCForUserSecurity(this.securityCompanyClientId, AppUserId).subscribe((res) => {
        this.sites = ((res as any[]) || []).map((i: any) => { if (!i.nameEN) { i.nameEN = i.nameEn || i.name; i.nameEn = i.nameEN; } return i; })
      }) 
    }else if(this.branchFilter==true){
      //console.log('branchfilter');
      this.getMarker();
      this.getBranches();
    }else{
      this.getMarker();
    }
  }
  display2(event: any) {
    this.siteId = [event.value];
    this.markers = [];
    this.getMarker();

  }

  getByBranchId({ value }: any) {
    this.branchId = [value.id]
    this.markers = [];
    this.getMarker();
  }

  deleteFilter() {
    this.flag = true;
    this.sites = null;
    this.data = null;
    this.branches = null;
    this.branchId=[];
    this.id = 0;
    this.securityCompanyClientId=[]
    this.reports.clientId.next(0);
    this.siteFilter = false;
    this.siteId = [];
    this.getMarker();
  }

  getBranches() {
    this.reports.GlobalApiFilter_GetAllSecurityBranch(this.companyId).subscribe((res) => {
      this.branches = ((res as any[]) || []).map((i: any) => { if (!i.nameEN) { i.nameEN = i.nameEn || i.name; i.nameEn = i.nameEN; } return i; });
    });
  }


  getAllReports() {
   
  
    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: this.mainLocation,
        zoom: 5,
        heading: 320,
        tilt: 47.5,
        mapId: "90f87356969d889c",
      }
    );
  
    const buttons: [string, string, number, google.maps.ControlPosition][] = [
      ["←", "rotate", 20, google.maps.ControlPosition.LEFT_CENTER],
      ["→", "rotate", -20, google.maps.ControlPosition.RIGHT_CENTER],
      ["↑", "tilt", 20, google.maps.ControlPosition.TOP_CENTER],
      ["↓", "tilt", -20, google.maps.ControlPosition.BOTTOM_CENTER],
    ];
  
    buttons.forEach(([text, mode, amount, position]) => {
      const controlDiv = document.createElement("div");
      const controlUI = document.createElement("button");
  
      controlUI.classList.add("ui-button");
      controlUI.innerText = `${text}`;
      controlUI.addEventListener("click", () => {
        adjustMap(mode, amount);
      });
      controlDiv.appendChild(controlUI);
      map.controls[position].push(controlDiv);
    });
  
    const adjustMap = function (mode: string, amount: number) {
      switch (mode) {
        case "tilt":
          map.setTilt(map.getTilt()! + amount);
          break;
        case "rotate":
          map.setHeading(map.getHeading()! + amount);
          break;
        default:
          break;
      }
    };
    this.mapMarkers=[];
    this.allCheckIn=[];
    this.report=[];
    this.markers=[];
    this.checkedIn=[];
    this.checkedOut=[];
    this.markers=[];
    let AppUserId = this.auth.snapshot.userInfo?.appUser.id
    let model
    model = {
      "securityCompanyId": this.companyId,
      "appUserId": AppUserId,
      "securityCompanyClientList":this.securityCompanyClientId,
      "securityCompanyBranchList": this.branchId,
      "clientSitesList":this.siteId,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "page": 1,
      "pageSize": 1000000,
      "searchKeyWord": ""
    }
    // if (this.securityCompanyClientId) {
    //   model.securityCompanyClientList = [this.securityCompanyClientId] as never[]
    // }
    // if (this.siteId) {
    //   model.clientSitesList = [this.siteId] as never[]
    // }
   // console.log(model);
 
    this.reports.GuardGuardsReportGetAllForSecurityCompanyFilter(model).subscribe((res: any) => {
      this.report = res.data
     
      
      //console.log(this.report);
      
      this.checkedOut = this.report?.filter((e: any) => e.isComplete);
      //console.log(this.checkedOut);
      this.allCheckOut = this.checkedOut
      this.break = this.report?.filter((e:any) => e.isOnBreak);
      this.allBreak = this.break
      this.checkedIn = this.report?.filter((e: any) => !e.isComplete);
      console.log(this.checkedIn);
      this.drawal = this.report?.filter((e: any) => e.isWithdrawal);
      this.withDrawned = this.drawal;
      this.allCheckIn=this.checkedIn
      this.checkedIn.forEach((x:any) => {
        //console.log(x);
        if (x.locationTracking) {
          const lat = parseFloat(x.locationTracking.lat);
          const lng = parseFloat(x.locationTracking.long);
      
          if (!isNaN(lat) && !isNaN(lng)) {
          //  console.log(lat, lng);
            const tempMarker = new google.maps.Marker({
              position: { lat, lng },
              map: map ,
              label: { text: x.name.split(" ")[0]+" "+x.name.split(" ")[2], className: 'marker' }
            });
            console.log(tempMarker);
            const siteLocationContent =
            x.siteLocationName !== null ? `<h6 class="">${x.siteLocationName}</h6>` : '<h6>لا يوجد</h6>';
           const siteNumberContent =  x.siteNumber !== null ?  `<h6 class="">${x.siteNumber}</h6>` : '<h6>لا يوجد</h6>';
            
            const infoWindow = new google.maps.InfoWindow({
              content: `<div class="row"><div class="col-8"><div class="row">
    <div class="col-6"><h6 class="text-muted">أسم المراقب</h6><h6 class="">`+x.name+`</h6></div>
    <div class="col-6"><h6 class="text-muted">تاريخ الميلاد</h6><h6 class="">`+x.birthDate+`</h6></div>
    <div class="col-6"><h6 class="text-muted">رقم التواصل</h6><h6 class="">`+x.phoneNumber+`</h6></div>
    <div class="col-6"><h6 class="text-muted">العمر</h6><h6 class="">`+x.age+`</h6></div>
    <div class="col-6"><h6 class="text-muted">رقم الهوية الوطنية</h6><h6 class="">`+x.nationalId+`</h6></div>
    <div class="col-6"><h6 class="text-muted">الكود</h6><h6 class="">`+x.guardCode+`</h6></div>
    </div></div>
    <div class="col-4"><img src="`+x.guardImage+`" class="Imgfluid rounded infoCardImg"/></</div></div><hr>
    <div class="row"><div class="col-4"><h6 class="text-muted">أسم الشركة الأمنية</h6><h6 class="">`+x.securityCompanyName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">الفرع</h6><h6 class="">`+x.clientName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">العميل</h6><h6 class="">`+x.branchName+`</h6></div></div><hr>
    <div class="row"><div class="col-4"><h6 class="text-muted">أسم الموقع</h6>`+siteLocationContent+`</div>
    <div class="col-4"><h6 class="text-muted">رقم الموقع</h6>`+siteNumberContent+`</div>
    <div class="col-4"><h6 class="text-muted">المشرف</h6><h6 class="">`+x.supervisorName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">المناوبة</h6><h6 class="">`+x.shiftName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">وقت الدخول</h6><h6 class="">`+x.startTime.split(' ')[1]+`</h6></div></div>
    `,
            });

            tempMarker.addListener('click', () => {
              infoWindow.open(map, tempMarker);
            }); 
          console.log(tempMarker);
       
            this.mapMarkers.push(tempMarker);
          }
           else {
            console.error(`Invalid latitude or longitude for marker: ${x.locationTracking}`);
          }
        }
      });
   
      console.log(this.mapMarkers);
      
    // this.markerCluster = new MarkerClusterer({map:map,markers:this.mapMarkers});
   
    const markerCluster = new MarkerClusterer({ map: map, markers: this.mapMarkers });
    //  const markerCluster = new MarkerClusterer({
    //   map: map,
    //   markers: this.mapMarkers,
    //   renderer: {
    //     imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    //   }
    // });
    });
  }
  openInfo(marker: any,content:string,guardCode:number ,guardImage:string,name:string ,birthDate:string, phoneNumber:number ,age:number
    , nationalId:number , securityCompanyName:string , branchName:string , clientName:string , 
    siteLocationName:string ,supervisorName:string , siteNumber:number , shiftName:string ,startTime:string ) {
    //console.log(guardImage);
    const siteLocationContent =
    siteLocationName !== null ? `<h6 class="">${siteLocationName}</h6>` : '<h6>لا يوجد</h6>';
   const siteNumberContent =  siteNumber !== null ?  `<h6 class="">${siteNumber}</h6>` : '<h6>لا يوجد</h6>';
    this.infoContent = `<div class="row"><div class="col-8"><div class="row">
    <div class="col-6"><h6 class="text-muted">أسم المراقب</h6><h6 class="">`+name+`</h6></div>
    <div class="col-6"><h6 class="text-muted">تاريخ الميلاد</h6><h6 class="">`+birthDate+`</h6></div>
    <div class="col-6"><h6 class="text-muted">رقم التواصل</h6><h6 class="">`+phoneNumber+`</h6></div>
    <div class="col-6"><h6 class="text-muted">العمر</h6><h6 class="">`+age+`</h6></div>
    <div class="col-6"><h6 class="text-muted">رقم الهوية الوطنية</h6><h6 class="">`+nationalId+`</h6></div>
    <div class="col-6"><h6 class="text-muted">الكود</h6><h6 class="">`+guardCode+`</h6></div>
    </div></div>
    <div class="col-4"><img src="`+guardImage+`" class="Imgfluid rounded infoCardImg"/></</div></div><hr>
    <div class="row"><div class="col-4"><h6 class="text-muted">أسم الشركة الأمنية</h6><h6 class="">`+securityCompanyName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">الفرع</h6><h6 class="">`+clientName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">العميل</h6><h6 class="">`+branchName+`</h6></div></div><hr>
    <div class="row"><div class="col-4"><h6 class="text-muted">أسم الموقع</h6>`+siteLocationContent+`</div>
    <div class="col-4"><h6 class="text-muted">رقم الموقع</h6>`+siteNumberContent+`</div>
    <div class="col-4"><h6 class="text-muted">المشرف</h6><h6 class="">`+supervisorName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">المناوبة</h6><h6 class="">`+shiftName+`</h6></div>
    <div class="col-4"><h6 class="text-muted">وقت الدخول</h6><h6 class="">`+startTime.split(' ')[1]+`</h6></div></div>
    `
   // console.log(this.infoContent);
    
    setTimeout(() => {
      this.infoWindow?.open(marker);
    }, 500);
  }


  open(Id:any){
    console.log(this.guardDetails.name);
    
    this._model.open(this.guardDetailsId)
  }

  close(id:string){
    this._model.close(id);
    this.stopTimer();
  }

  details(data:AttendanceReport){
    if(data != null){
    this.guardDetails=data;
   //this.guardDetailsId=data.guardCode.toString();
   if( this.guardDetails!=null){
    //console.log(this.guardDetails);
    this.convertDateFormat(this.guardDetails.startTime)
    this.open(this.guardDetailsId)

   }
  }
  }


   convertDateFormat(inputDate: string) {
   
    const [datePart, timePart] = inputDate.split(' ');
  
    const [day, month, year] = datePart.split('-').map(part => parseInt(part, 10));
  
    const [hour, minute, second] = timePart.split(':').map(part => parseInt(part, 10));
  
    const newDate = new Date(year, month - 1, day, hour, minute, second);

 // console.log(newDate);
  
    this.timer(newDate)
  }

  timer(startDate:Date) {
    this.timerSubscription = interval(1000).subscribe(() => {
      //const startDate = new Date('2024-04-15T08:00:00'); // Your specific start date
      const currentDate = new Date();
     // console.log(startDate);
      
      const timeDifference = currentDate.getTime() - startDate.getTime();

      this.days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
      this.minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
      this.seconds = Math.floor((timeDifference / 1000) % 60);
    });
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }


  search(searchtype:string){
    if(searchtype == 'checkIn'){
      this.checkedIn = this.allCheckIn
      //console.log(this.checkedIn);
      let myData: any[] = [];
      if (this.searchKey != '') {
        console.log(this.searchKey);
        
        this.checkedIn.filter((ele: any) => {
          let name = ele.name.toLowerCase() 
          let number = ele.phoneNumber
          if (
            name.includes(this.searchKey.replace(/\s/g, '').toLowerCase() ) || number?.includes(this.searchKey.replace(/\s/g, ''))
          ) {
            myData.push(ele);
          }
        });
        this.checkedIn = myData;
      } else {
        this.checkedIn = this.allCheckIn;
      }
    }else if(searchtype == 'checkOut'){
      this.checkedOut = this.allCheckOut
      //console.log(this.checkedOut);
      let myData: any[] = [];
      if (this.searchKey != '') {
        //console.log(this.searchKey);
        
        this.checkedOut.filter((ele: any) => {
         // console.log(ele.name);
          
          let name = ele.name.toLowerCase() 
          let number = ele.phoneNumber
          if (
            name.includes(this.searchKey.replace(/\s/g, '').toLowerCase()) || number?.includes(this.searchKey.replace(/\s/g, ''))
          ) {
            
            myData.push(ele);
          }
        });
        this.checkedOut = myData;
      } else {
        this.checkedOut = this.allCheckOut;
      }
    }else if(searchtype == 'checkBreak'){
      this.break = this.allBreak
      //console.log(this.break);
      let myData: any[] = [];
      if (this.searchKey != '') {
        console.log(this.searchKey);
        
        this.break.filter((ele: any) => {
          console.log(ele.name);
          
          let name = ele.name.toLowerCase() 
          let number = ele.phoneNumber
          if (
            name.includes(this.searchKey.replace(/\s/g, '').toLowerCase() ) || number?.includes(this.searchKey.replace(/\s/g, ''))
          ) {
            //console.log(name.includes(this.searchKey.replace(/\s/g, '')));
            
            myData.push(ele);
          }
        });
        this.break = myData;
      } else {
        this.break = this.allBreak ;
      }
    }else if(searchtype == 'checkDrawal'){
      this.drawal = this.withDrawned
      //console.log(this.withDrawned);
      let myData: any[] = [];
      if (this.searchKey != '') {
        console.log(this.searchKey);
        
        this.drawal.filter((ele: any) => {
          //console.log(ele.name);
          
          let name = ele.name.toLowerCase() 
          let number = ele.phoneNumber
          if (
            name.includes(this.searchKey.replace(/\s/g, '').toLowerCase() ) || number?.includes(this.searchKey.replace(/\s/g, ''))
          ) {
            //console.log(name.includes(this.searchKey.replace(/\s/g, '')));
            
            myData.push(ele);
          }
        });
        this.drawal = myData;
      } else {
        this.drawal = this.withDrawned ;
      }
    }
    }

  withdrawndetails(data:AttendanceReport){
   //console.log(data);
  this.withdrawnGuardDetails = data;
  this.reports.GetAllAttendanceWithdrawalLog(data.id).subscribe((res)=>{
  console.log(res);
  this.guardWithDrawns = res;
  this._model.open(this.withdrawndetailsId)
  })
  }

  // safeCheckPointId(id: string): string {
  //   return 'id_' + id.replace(/[^a-zA-Z0-9]/g, '_');
  // }


  // guardWithDrawnDetails(drawnData:AttendanceReport){
  //   console.log(drawnData);
    
  // this.guardDrawnDetails = drawnData;
  // this._model.open(this.withdrawnApprove)
  // }



  accept(data:object){
    this.guardDrawnDetails = data;
    this.withdrawalStatus = 1;
    this._model.open(this.withdrawnApprove)
  }
  refuse(data:object){
    this.guardDrawnDetails = data;
    this.withdrawalStatus = 2;
    this._model.open(this.withdrawnApprove)
  }


  onSubmit(){
    //console.log(this.guardDrawnDetails);
    
    if(this.reasonForm.valid){
      this.reports.UpdateWithdrawalLog(this.guardDrawnDetails.id , this.withdrawalStatus , this.reasonForm.controls['Notes'].value).subscribe((res)=>{
        console.log(res);
        this._model.close(this.withdrawnApprove)
      });
    }
  }



  voiceCall(guardDetails: any) {

    console.log(guardDetails);
    const targetUser: ZegoUser = {
      userID: guardDetails.guardCode,
      userName: guardDetails.name,
      //setUserAvatar :(guardDetails.guardImage)
    };


    const params = {
      callees: [targetUser],
      callType: ZegoUIKitPrebuilt.InvitationTypeVoiceCall,
      timeout: 60,
      notificationConfig: {
        resourcesID:'zegouikit_call',
        title:'Call invitation', 
        message:'Incoming video call...'
    }
    };

    console.log(params);
    

    this.zg.sendCallInvitation(params)
      .then((res) => {
        console.warn("Invitation result:", res);
        console.log(res);
        // Handle response
      })
      .catch((err) => {
        console.warn("Invitation error:", err);
        // Handle error
        console.log(err);
      });

  //     this.zg.joinRoom({
  //       // ...,
  //      onUserAvatarSetter:(userList) => {
  //          userList.forEach(user => { user.setUserAvatar?.((guardDetails.guardImage)) });

  //      }
  //  });
  }

  videoCall(guardDetails: any) {

    console.log(guardDetails);
    const targetUser: ZegoUser = {
      userID: guardDetails.guardCode,
      userName: guardDetails.name,
    };

    const params = {
      callees: [targetUser],
      callType: ZegoUIKitPrebuilt.InvitationTypeVideoCall,
      timeout: 60,
      notificationConfig: {
        resourcesID:'zegouikit_call',
        title:'Call invitation', 
        message:'Incoming video call...'
    }
    };
    this.zg.sendCallInvitation(params)
      .then((res) => {
        console.warn("Invitation result:", res);
        console.log(res);
        // Handle response
      })
      .catch((err) => {
        console.warn("Invitation error:", err);
        // Handle error
        console.log(err);
      });
  
  }
}
